import isServerSideRendering from '~/utilities/isServerSideRendering';

let size: number | undefined;

export default function scrollbarSize(recalculate?: boolean) {
  if (isServerSideRendering || (size != null && !recalculate)) {
    return size;
  }

  const scrollDiv = document.createElement('div');
  scrollDiv.style.position = 'absolute';
  scrollDiv.style.top = '-9999px';
  scrollDiv.style.width = '50px';
  scrollDiv.style.height = '50px';
  scrollDiv.style.overflow = 'scroll';

  document.body.appendChild(scrollDiv);
  size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);

  return size;
}
